import Toastr from "../../../itrust_common/components/Toastr"

const PARENT = 'MARKETING_BLAST_'

const DEFAULT_STATE = {
  patients: [],
  meta: { pagination: {} },
  saving: false,
  loading: false,
  editing: false
}
let changes = null;
export default function patientsReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {
    case `${PARENT}PATIENTS_LOAD_PENDING`:
      return { ...state, loading: true };

    case `${PARENT}PATIENTS_LOAD_REJECTED`:
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = {
        saving: false,
        loading: false,
      }
      return { ...state, ...changes };

    case `${PARENT}PATIENTS_LOAD_FULFILLED`:
      changes = {
        saving: false,
        loading: false,
        ...response
      }
      return { ...state, ...changes };

    default:
      return state;
  }
}